import discount from '../../fields/shared/discount';

export const MUTATION_ADD_DISCOUNT = /* GraphQL */ `
	mutation($input: DiscountInput!) {
		addDiscount(input: $input) {
			${discount}
		}
	}
`;
